<script>
export default {
  name: 'UserCard',
  props: {
    user: Object
  },
  computed: {
    role() {
      if (this.user.isOwner) return this.$t('Owner');
      if (this.user.isAdmin) return this.$t('Admin');
      return this.$t('Client');
    }
  }
};
</script>

<template>
  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
    <div class="user-card">
      <router-link :to="{ name: 'User', params: { userId: user.id } }" class="user-card-avatar">
        <img
          :alt="$t('Photo of {name}', { name: user.name })"
          :src="user.avatar ? user.avatar : require('@/assets/user-light.svg')"
        />
      </router-link>
      <div class="user-card-name">
        <router-link :to="{ name: 'User', params: { userId: user.id } }">
          {{ user.name }}
          <el-tooltip :content="$t('Two-factor Authentication')" placement="top">
            <span v-if="user.requiresTfa" class="user-card-tfa">2FA</span>
          </el-tooltip>
        </router-link>
      </div>
      <div class="user-card-role">
        {{ role }}
      </div>
      <div class="user-card-last-seen text-truncate">
        <span v-if="user.lastSeen">
          {{ $t('Last seen {date}', { date: $d(new Date(user.lastSeen), 'short') }) }}
        </span>
        <span v-else>
          {{ $t('Never logged in') }}
        </span>
      </div>
      <div v-if="$store.state.user.canManageUsers" class="user-card-settings">
        <router-link
          :to="
            $store.state.user.id === user.id
              ? { name: 'EditProfile' }
              : { name: 'EditUser', params: { userId: user.id } }
          "
          :title="$t('Edit')"
        >
          <i class="el-icon-fa-cog" />
        </router-link>
      </div>
    </div>
  </el-col>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.user-card {
  position: relative;
  min-height: 6.5rem;
  background: $--color-white;
  border-radius: 0.25rem;
  box-shadow: $--box-shadow-small;
  padding: 0.75rem 1rem 0.75rem 7.5rem;
  margin-bottom: 2rem;
  user-select: none;

  @include breakpoint('sm-and-down') {
    margin-bottom: 1rem;
  }
}

.user-card-avatar {
  display: flex;
  align-items: center;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 6.5rem;
  height: 6.5rem;

  img {
    width: 100%;
    height: 100%;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    display: block;
  }
}

.user-card-name {
  margin: 0.45rem 0;
}

.user-card-tfa {
  border: solid 1px $--color-success;
  color: $--color-success;
  font-weight: bold;
  font-size: 0.75rem;
  padding: 0 0.125rem;
  border-radius: 0.25rem;
}

.user-card-role,
.user-card-last-seen {
  font-size: $--font-size-small;
  color: $--color-gray-40;
  padding-right: 1.5rem;
  margin: 0.25rem 0;
}

.user-card-last-seen {
  font-style: italic;
}

.user-card-settings {
  position: absolute;
  right: 1rem;
  bottom: 1rem;
  font-size: 1.1rem;

  a {
    color: $--color-gray-40;
  }

  a:hover {
    color: darken($--color-gray-40, 7.5%);
  }
}
</style>
